module.exports = __webpack_public_path__ + "img/parrot.4798a624.png";